/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlaceInformationLinkDto { 
    link?: string;
    type?: PlaceInformationLinkDto.TypeEnum;
}
export namespace PlaceInformationLinkDto {
    export type TypeEnum = 'MENU' | 'TIK_TOK' | 'GOOGLE' | 'TRIPADVISOR' | 'FACEBOOK' | 'INSTAGRAM' | 'TWITTER' | 'LINKEDIN' | 'YOUTUBE' | 'WEBSITE' | 'OTHER';
    export const TypeEnum = {
        Menu: 'MENU' as TypeEnum,
        TikTok: 'TIK_TOK' as TypeEnum,
        Google: 'GOOGLE' as TypeEnum,
        Tripadvisor: 'TRIPADVISOR' as TypeEnum,
        Facebook: 'FACEBOOK' as TypeEnum,
        Instagram: 'INSTAGRAM' as TypeEnum,
        Twitter: 'TWITTER' as TypeEnum,
        Linkedin: 'LINKEDIN' as TypeEnum,
        Youtube: 'YOUTUBE' as TypeEnum,
        Website: 'WEBSITE' as TypeEnum,
        Other: 'OTHER' as TypeEnum
    };
}


